// import React, { FC, ReactNode } from "react";
// import styles from "./DisplayBox.module.css";

// interface DisplayBoxProps {
//   text?: string;
//   icon?: string;
//   className?: string;
//   textClass?: string;
//   iconClass?: string;
//   onClick?: () => void;
//   style?:React.CSSProperties;
//   iconClassName?:string
//   isEdit?:boolean
//   icon1?:string
//   iconStyle?:React.CSSProperties
//   onEdit?:() => void
//   isDraggble?:boolean
// }

// const DisplayBox: FC<DisplayBoxProps> = ({ text, icon, className, textClass, iconClass,onClick,style,iconClassName,isEdit,icon1,iconStyle,onEdit,isDraggble}) => {
//   return (
//     <div className={`${styles.displayBox} ${className || ""}`} style={style}>
//       <div style={{display:'flex',gap:'0.5rem'}}>
//       {isEdit && (<button onClick={onEdit} className={`${styles.icon} ${iconClassName || ""}`}>
//         <svg className={`${styles.displayBox__icon} ${iconClass || ""}`} style={iconStyle}>
//           <use xlinkHref={`/assets/sprite.svg#icon-${icon1}`} />
//         </svg>
//      </button>)}
//     <button onClick={onClick} className={`${styles.icon} ${iconClassName || ""}`}>
//         <svg className={`${styles.displayBox__icon} ${iconClass || ""}`}>
//           <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
//         </svg>
//     </button>
//       </div>
    
// <div>
// <span className={`${styles.displayBox__text} ${textClass || ""}`}>{text}</span>
// { isDraggble && (  <button onClick={on} className={`${styles.icon} ${iconClassName || ""}`}>
//         <svg className={`${styles.displayBox__icon} ${iconClass || ""}`}>
//           <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
//         </svg>
//     </button>)
// }
// </div>
      
//     </div>
//   );
// };

// export default DisplayBox;


import React, { FC } from "react";
import styles from "./DisplayBox.module.css";

interface DisplayBoxProps {
  text?: string;
  icon?: string;
  className?: string;
  textClass?: string;
  iconClass?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  iconClassName?: string;
  isEdit?: boolean;
  icon1?: string;
  iconStyle?: React.CSSProperties;
  onEdit?: () => void;
  isDraggble?: boolean;
  dragIcon?: string; 
  onDragStart?: (event: React.DragEvent<HTMLButtonElement>) => void; 
}

const DisplayBox: FC<DisplayBoxProps> = ({
  text,
  icon,
  className,
  textClass,
  iconClass,
  onClick,
  style,
  iconClassName,
  isEdit,
  icon1,
  iconStyle,
  onEdit,
  isDraggble,
  dragIcon = "move",
  onDragStart,
}) => {
  return (
    <div className={`${styles.displayBox} ${className || ""}`} style={style}>
      <div style={{ display: "flex", gap: "0.5rem" }}>
        {isEdit && (
          <button
            onClick={onEdit}
            className={`${styles.icon} ${iconClassName || ""}`}
          >
            <svg
              className={`${styles.displayBox__icon} ${iconClass || ""}`}
              style={iconStyle}
            >
              <use xlinkHref={`/assets/sprite.svg#icon-${icon1}`} />
            </svg>
          </button>
        )}

        <button
          onClick={onClick}
          className={`${styles.icon} ${iconClassName || ""}`}
        >
          <svg className={`${styles.displayBox__icon} ${iconClass || ""}`}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        </button>
      </div>

      <div className={styles.displayBoxContent} style={{display:'flex',flexDirection:'row-reverse',alignItems:'center',gap:'2rem'}}>
        <span className={`${styles.displayBox__text} ${textClass || ""}`}>
          {text}
        </span>

        {isDraggble && (
          <button
            draggable
            onDragStart={onDragStart}
            className={`${styles.icon} ${iconClassName || ""}`}
            style={{cursor:'move'}}
          >
            <svg className={`${styles.drag__icon} ${iconClass || ""}`}>
              <use xlinkHref={`/assets/sprite.svg#icon-${dragIcon}`} />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default DisplayBox;



